import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { AlertModule } from 'ngx-alerts';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgHttpLoaderModule } from 'ng-http-loader';
 
import { ModalModule } from 'ngx-bootstrap/modal';
import { FilteredSelectModule } from "filtered-select";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { MatSelectFilterModule } from 'mat-select-filter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { UnidadComponent } from './unidades/unidad/unidad.component';
import { ProductoComponent } from './producto/producto.component';
import { EmisorComponent } from './emisor/emisor.component';
import { ProveedorComponent } from './proveedor/proveedor/proveedor.component';
import { ClienteComponent } from './cliente/cliente.component';
import { FormaPagoComponent } from './forma-pago/forma-pago.component';
import { GrupoComponent } from './grupo/grupo.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { ListaComprasComponent } from './lista-compras/lista-compras.component';
import { ComprasComponent } from './compras/compras/compras.component';
import { VercomprasComponent } from './vercompras/vercompras.component';
import { ComprobanteComponent } from './comprobante/comprobante.component';
import { CuentasxcobrarComponent } from './cuentasxcobrar/cuentasxcobrar.component';
import { AbonosComponent } from './abonos/abonos.component';
import { EnularFacturaComponent } from './enular-factura/enular-factura.component';
import { KardexComponent } from './kardex/kardex/kardex.component';
import { InventarioComponent } from './reporte/inventario/inventario.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { IventarioFisicoComponent } from './iventario-fisico/iventario-fisico.component';
import { VentasComponent } from './reporte/ventas/ventas.component';
import { VentasMesComponent } from './reporte/ventas-mes/ventas-mes.component';
import { VentaProdComponent } from './reporte/venta-prod/venta-prod.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DocumentoelectronicosComponent } from './documentoelectronicos/documentoelectronicos.component';
import { UtilidadComponent } from './reporte/utilidad/utilidad.component';

import { VendedorComponent } from './vendedor/vendedor.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { PedidosComponent } from './pedidos/pedidos.component';
import { VerpedidoComponent } from './verpedido/verpedido.component';
import { CalidadComponent } from './calidad/calidad.component';

import { EgresoComponent } from './egreso/egreso.component';
import { EmpleadoComponent } from './empleado/empleado.component';
import { FacturaTouchComponent } from './factura-touch/factura-touch.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RetencionVentasComponent } from './retencion-ventas/retencion-ventas.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { OrderModule } from 'ngx-order-pipe';
import { CuentasxCobrarComponent } from './reporte/cuentasx-cobrar/cuentasx-cobrar.component';
import { TabDirective } from './TabDirective';
import { ClientesProveedorComponent } from './reporte/clientes-proveedor/clientes-proveedor.component';
import { FacturaXlsComponent } from './factura-xls/factura-xls.component';
import { RetencionComprasComponent } from './retencion-compras/retencion-compras.component';
import { CaducidadComponent } from './reporte/caducidad/caducidad.component';
import { CajaComponent } from './caja/caja.component';
import { Ng2VirtualKeyboardModule } from 'ng2-virtual-keyboard';
import { ReporteCajaComponent } from './reporte-caja/reporte-caja.component';
import { OfflineInterceptor } from './offline-interceptor';
import { ReimprimirComponent } from './reimprimir/reimprimir.component';
import { CanalesComponent } from './canales/canales.component';


@NgModule({
  imports: [
    Ng2VirtualKeyboardModule,
    OrderModule,
    MatSelectModule,
    MatFormFieldModule,
    ShowHidePasswordModule,
    NgSelectModule,
    ShowHidePasswordModule,
        NgOptionHighlightModule,

    NgxMatSelectSearchModule,
    BrowserModule,
    MatSelectFilterModule ,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,

    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    NgHttpLoaderModule.forRoot(), 
    ModalModule.forRoot(),  
    HttpClientModule,

    FormsModule,
    ReactiveFormsModule,
    MDBBootstrapModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    AlertModule.forRoot({maxMessages: 5, timeout: 5000}),
    NgbModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  
    schemas: [ NO_ERRORS_SCHEMA ],
  
  declarations: [
    
    TabDirective,
    AppComponent, 
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    UnidadComponent,
    ProductoComponent,
    EmisorComponent,
    ClienteComponent,
    ProveedorComponent,
    FormaPagoComponent,
    GrupoComponent,
    FacturacionComponent,
    ListaComprasComponent,
    ComprasComponent,
    VercomprasComponent,
    ComprobanteComponent,
    CuentasxcobrarComponent,
    AbonosComponent,
    EnularFacturaComponent,
    PedidosComponent,
    KardexComponent,
    InventarioComponent,
   
    IventarioFisicoComponent,
    VentasComponent,
    VentasMesComponent,
    VentaProdComponent,
    DocumentoelectronicosComponent,
    UtilidadComponent,

    VendedorComponent,

    VerpedidoComponent,

    CalidadComponent,

    EgresoComponent,

    EmpleadoComponent,

    FacturaTouchComponent,

    RetencionVentasComponent,

    CuentasxCobrarComponent,
    
    ClientesProveedorComponent,
    
    FacturaXlsComponent,
    
    RetencionComprasComponent,
    
    CaducidadComponent,
    
    CajaComponent,
    
    ReporteCajaComponent,
    
    ReimprimirComponent,
    
    CanalesComponent,
    
    
    
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
    
  },[DatePipe]] ,
  /*{ 
    provide: HTTP_INTERCEPTORS, 
 useClass: OfflineInterceptor, 
    multi: true  // Mantienes el interceptor para manejar las peticiones offline
  }, [DatePipe]],*/
  
  bootstrap: [ AppComponent ]
})
export class AppModule { 

  
}
